<template>
  <div class="section_column">
    <div class="section_column__title">
      <h2>{{ title }}</h2>
    </div>
    <div class="section_column__orders">
      <CardOrder v-for="order in orders" :key="order.id" :order="order" />
    </div>
  </div>
</template>

<script>
import CardOrder from '@/components/planner/CardOrder.vue'

export default {
  name: 'SectionColumn',
  components: {
    CardOrder
  },
  props: {
    title: {
      type: String
    },
    orders: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
  .section_column {
    width: 25%;
    min-width: 450px;
    &__title {
      & h2 {
        text-align: center;
        font-size: 1.4rem;
        font-weight: bold;
      }
    }
    &__orders {
      padding: 12px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      max-height: calc(100vh - 122px);
      overflow-y: scroll;
    }
  }
</style>
